import * as types from "../types";
import { requestAuth } from "../../helpers/FetchApi";
import appSettings from "../../AppSettings";
import { ActionsCreators } from "../../actions";
import { toast } from "react-toastify";
import strings from "../../helpers/Localization";

export const actionCreators = {
    GetContentGroupsList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => async (dispatch, store) => {

        secondary ? dispatch({ type: types.GET_CONTENTGROUPS_SECONDARY_COMPLETED, payload: null }) : dispatch({ type: types.GET_CONTENTGROUPS_COMPLETED, payload: null });
        if (pageSize < 0) {return onSuccess(null);}
        await requestAuth(appSettings.SKALINKAPIURL + "/api/ContentGroups/OrganizationContentGroups/" + store().currentuser.currentorganization.id + "?"
                + "pageNumber=" + pageNumber
                + "&pageSize=" + pageSize
                + (sortExpression ? "&sortExpression=" + sortExpression : "")
                + (filterExpression ? "&filterExpression=" + filterExpression : "")
        , {
            method: "GET"
        }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            secondary ? dispatch({ type: types.GET_CONTENTGROUPS_SECONDARY_COMPLETED, payload: data }) : dispatch({ type: types.GET_CONTENTGROUPS_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    GetSecondaryContentGroupsList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess) => (dispatch) => {
        dispatch(ActionsCreators.GetContentGroupsList(pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, true));
    },

    GetContentGroup: (id, onSuccess) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/ContentGroups/" + id, {
            method: "GET"
        }).then((data) => {
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    DeleteContentGroup: (Id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/ContentGroups/" + Id, {
            method: "DELETE"
        }).then((data) => {
            toast.success(strings.cgDeleted);
            if (onSuccess) {onSuccess();}
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    EditContentGroup: (changedContentGroup, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/ContentGroups/" + changedContentGroup.id, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(changedContentGroup),
            method: "PUT"
        }).then((data) => {
            toast.success(strings.cgSaved);
            onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
            // alert("error", data);
        });

    },

    CreateContentGroup: (newContentGroup, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/ContentGroups", {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(newContentGroup),
            method: "POST"
        }).then((data) => {
            toast.success(strings.cgSaved);
            if (onSuccess) {onSuccess(data);}
        }).catch( (data) => {
            console.log("error", data);
        });
    }

};
